/* Action Types */
export const LOAD_DISCOVER_ITEMS_FAIL = 'LOAD_DISCOVER_ITEMS_FAIL';
export const LOAD_DISCOVER_ITEMS_REQUEST = 'LOAD_DISCOVER_ITEMS_REQUEST';
export const LOAD_DISCOVER_ITEMS_SUCCESS = 'LOAD_DISCOVER_ITEMS_SUCCESS';
export const LOAD_SHOULD_DISCOVER_SUCCESS = 'LOAD_SHOULD_DISCOVER_SUCCESS';
